import React from "react";
import { connect } from "react-redux";

import { HubContextMenu } from "../../components";
import { setIsOpenDialog } from "../../redux";

export const IndustriesContextMenu = ({
  id,
  customerCount = 0,
  vendorCount = 0,
  setDeletingId = () => {},
  _setIsOpenDialog = () => {},
  ...rest
}) => {
  const hasAssociations = customerCount > 0 || vendorCount > 0;

  const MENU_ITEMS = [
    {
      id: "edit",
      label: "Edit Industry",
      icon: "Edit",
    },
    {
      id: "delete",
      label: "Delete",
      icon: "Trash2",
      color: hasAssociations ? "grey" : "redError",
      disabled: hasAssociations,
    },
  ];

  const onSelect = (item) => {
    switch (item?.id) {
      case "edit":
        _setIsOpenDialog("edit-industry", id);
        break;
      case "delete":
        if (!hasAssociations) {
          setDeletingId(id);
        }
        break;
      default:
        break;
    }
  };

  return (
    <HubContextMenu
      id={"industries"}
      loading={false}
      menuItems={MENU_ITEMS}
      onSelect={onSelect}
      IconButtonProps={{ sx: { padding: 0 } }}
      {...rest}
    />
  );
};

const mapDispatchToProps = {
  _setIsOpenDialog: setIsOpenDialog,
};

export default connect(null, mapDispatchToProps)(IndustriesContextMenu);